/* global digitalData */

function addDigitalDataObject() {
  var adobeObj = {}
  adobeObj.page = digitalData && digitalData.page ? digitalData.page : {}
  adobeObj.user = digitalData && digitalData.user ? digitalData.user : {}
  if (adobeObj.page && adobeObj.page.pageInfo && adobeObj.page.pageInfo.popName) {
    delete adobeObj.page.pageInfo.popName
  }else{
    adobeObj.page['pageInfo'] = {};
  }
  return adobeObj
  // return {};
}

export default addDigitalDataObject



// WEBPACK FOOTER //
// ./src/common/tracking.js